module.exports = __webpack_public_path__ + "622ea54f3ceecbe56195dc0c0bb9c6eb.png";